import React from "react";
import { Oportunidades } from "../../components";
import "./stylesOportunidad.scss";

export const Oportunidad = () => (
  <>
    <Oportunidades />
  </>
);
